import { useContext, useMemo } from 'react';

import { SpookyLogo } from './fall';
import { SeasonalThemeContext } from './seasonal-theme-context';

/**
 * Hook to get the appropriate logo based on seasonal theme
 * Returns the spooky logo when fall theme is enabled, undefined otherwise
 *
 * Note: If used outside of SeasonalThemeProvider, returns undefined (graceful degradation)
 */
export const useSeasonalLogo = () => {
	const context = useContext(SeasonalThemeContext);

	// Gracefully handle usage outside of provider
	const isSeasonalThemeEnabled = context?.isSeasonalThemeEnabled ?? false;

	// Memoize the return value to prevent unnecessary re-renders
	return useMemo(
		() => ({
			logoUrl: isSeasonalThemeEnabled ? SpookyLogo : undefined,
			isSeasonalTheme: isSeasonalThemeEnabled,
		}),
		[isSeasonalThemeEnabled]
	);
};
